/* src/app/shared/dialog/confirm-dialog/confirm-dialog.component.scss */
.dialog-actions {
  margin-top: 20px;
  padding: 5px;
}
.button-div {
  position: relative;
  padding: 0 5px;
}
/*# sourceMappingURL=confirm-dialog.component.css.map */
